import { hexToRGB } from "@shared/utils/misc";
import { SMALL_MOBILE } from "@shared/common/constants";
import { css } from "styled-components";
import { typography } from "@shared/common/Themes/typography";

const space = [4, 8, 16, 32, 64, 128];
const isDarkMode = false;
// Colors
const black = "#000000";
const layoutBgColor = "#FCFEFF";
const cardBgColor = "#FFFFFF";
const secondaryCardBgColor = "#FFFFFF";
const bgColor = cardBgColor;
const mediumBgColor = cardBgColor;
const lightBackground = "#FAFAFA";

const primaryBlue = "#3272FE";
const midBlue = "#D6E3FF";
const lightBlue = "#EFF4FF";
const primaryGrey = "#2E3D5C";
const mediumGrey = "#576070";
const secondaryGrey = "#8992A3";
const lightestGrey = "#B9B9BB";
const midDark = secondaryGrey;

const primaryText = primaryGrey;
const secondaryText = secondaryGrey;
const mediumText = mediumGrey;
const lightestText = lightestGrey;

const lightestBorderGrey = hexToRGB(secondaryGrey, 0.12);
const lightBorderGrey = hexToRGB(secondaryGrey, 0.19);
const mediumBorderGrey = hexToRGB(secondaryGrey, 0.27);
const hardBorderGrey = hexToRGB(secondaryGrey, 0.45);

const basic = black;
const titleColor = basic;
const textColor = basic;
const buttonText = "#FFFFFF";

const layoutFooterColor = "#002766";
const titleCardBgColor = lightBlue;
const tableHoverBgColor = lightBackground;
const selectedTableColumnBgColor = "#F5F5F5";
const emptyColor = lightBackground;
const activeBgColor = "#FFFFFF";
const pieChartBorderColor = "#8992A366";
const hoverBgColor = lightestBorderGrey;
const chartTicksColor = "#2E3D5C66";
const chartGridColor = "#8992A328";
const avatarBgColor = "#fEEAD9";
const avatarColor = "#F56A00";
const activeMenuItemBgColor = "#F0F7FF";
const dashboardCoinsBgColor = "#949BA80C";
const dashboardStatisticsBgColor = "#949BA80C";
const disabledInput = "#F5F5F5";
const inputBorderColor = "#C4C8D1";
const tagBgColor = lightBlue;
const tvCurrentPriceColor = "#E3E9EC";
const boxInCardColor = lightBackground;
const highlightBgColor = lightBlue;
const subMenuTitleBgColor = "#E1F5FE40";
const checkboxBorderColor = "#D9D9D9";
const filterChipsColor = "#ECEDF0";
const filterChipsActiveColor = primaryGrey;
const bannerTextColor = "#292B33";
const statisticsBgColor = "#F9FAFB";
const cardLightBgColor = "#F6F8FB";
const refreshSpinnerBgColor = "#FFFFFF";
const billingBgColor = "#FCFCFD";
const paymentBgColor = cardBgColor;

const blues = ["#EFF4FF", "#CEDCFC", "#B3C9FB", "#77A2FF", primaryBlue];
const pieChartColors = ["#292B33", "#3272FE", "#9E32FD", "#FEB932", "#53A5E4"];
const demoTagColors = ["#9E32FE", "#0F54E9"];

//colors for old dark mode theme
const buttonBgColor = primaryBlue;
const graphColor = primaryBlue;
const secondaryIconBg = "#EDF4F7";

export const colors = {
  green: "#14CB17",
  lightGreen: "#75E3A1",
  red: "#FD6157",
  secondaryRed: "#DB3328",
  orange: "#E79900",
  yellow: "#FEB932",
  darkYellow: "#E79900",
  gold: "#F47601",
  lightGrey: "#E0E2E4",
  primary: primaryBlue,
  white: "#FFFFFF",
  disabledText: hexToRGB(secondaryText, 0.5),
  black,
  purple: "#9E32FE",
  pink: "#EA32FE",
  primaryGrey,
  mediumGrey,
  secondaryGrey,
  lightBorderGrey,
  lightestBorderGrey,
  lightestGrey,
  primaryText,
  secondaryText,
  lightestText,
  primaryBlue,
  blues,
  pieChartColors,
  cardBgColor,
  bgColor,
  layoutBgColor,
  layoutFooterColor,
  titleColor,
  textColor,
  basic,
  buttonText,
  titleCardBgColor,
  tableHoverBgColor,
  selectedTableColumnBgColor,
  emptyColor,
  hoverBgColor,
  lightBackground,
  chartTicksColor,
  chartGridColor,
  avatarBgColor,
  avatarColor,
  activeMenuItemBgColor,
  pieChartBorderColor,
  mediumBorderGrey,
  hardBorderGrey,
  dashboardCoinsBgColor,
  dashboardStatisticsBgColor,
  disabledInput,
  midDark,
  tagBgColor,
  inputBorderColor,
  tvCurrentPriceColor,
  boxInCardColor,
  lightBlue,
  highlightBgColor,
  subMenuTitleBgColor,
  checkboxBorderColor,
  filterChipsColor,
  bannerTextColor,
  midBlue,
  statisticsBgColor,
  demoTagColors,
  cardLightBgColor,
  refreshSpinnerBgColor,
  filterChipsActiveColor,
  mediumText,
  billingBgColor,
  paymentBgColor,
  mediumBgColor,
  activeBgColor,
  secondaryCardBgColor,
  buttonBgColor,
  graphColor,
  secondaryIconBg,
};

export const zIndexes = {
  modalBackground: 1099,
  modal: 1001,
  drawer: 1000,
  popover: 999,
  actionButton: 900,
};

export const SCROLLBAR_SIZE = 12;
export const MOBILE_SCROLLBAR_SIZE = 8;
export const baseScrollbarStyle = css`
  ul::-webkit-scrollbar,
  div::-webkit-scrollbar,
  &::-webkit-scrollbar {
    width: ${SCROLLBAR_SIZE}px;
    height: ${SCROLLBAR_SIZE}px;
  }
  ul::-webkit-scrollbar-track,
  div::-webkit-scrollbar-track,
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  @media (max-width: ${SMALL_MOBILE}) {
    ul::-webkit-scrollbar,
    div::-webkit-scrollbar,
    &::-webkit-scrollbar {
      width: ${MOBILE_SCROLLBAR_SIZE}px;
      height: ${MOBILE_SCROLLBAR_SIZE}px;
    }
  }
`;
export const scrollbarStyle = css`
  ${baseScrollbarStyle};
  ul::-webkit-scrollbar-thumb,
  div::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-thumb {
    border: 2px solid transparent;
    background-color: #b9b9bb99;
    border-radius: 100px;
    background-clip: content-box;
  }
`;

const shadows = {
  card: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
  hoverCard: "rgba(154,160,185,.2) 0 15px 20px",
  symbolCard: "rgba(111, 117, 124, 0.25) 0 8px 24px",
  dashboardCard: "rgb(149 157 165 / 20%) 0px 2px 10px 1px",
};

const borders = {
  lightest: `1px solid ${colors.lightestBorderGrey}`,
  light: `1px solid ${colors.lightBorderGrey}`,
  medium: `1px solid ${colors.mediumBorderGrey}`,
  hard: `1px solid ${hexToRGB(secondaryGrey, 0.7)}`,
};

const AppTheme = {
  isDarkMode,
  space,
  colors,
  zIndexes,
  typography,
  shadows,
  borders,
  scrollbarStyle: {},
};
AppTheme.scrollbarStyle = scrollbarStyle;

export type AppThemeType = typeof AppTheme;

export default AppTheme;
